import { computed, inject, Injectable, Signal } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

export const MOBILE_WIDTH = 1050; // pixels
export const TABLET_WIDTH = 1400; // pixels

/**
 * Holds state for the current client screen size.
 */
@Injectable({
    providedIn: 'root',
})
export class ScreenSizeService {
    private breakPointObserver = inject(BreakpointObserver);

    // Private observer state
    private isMobile = toSignal(
        this.breakPointObserver.observe(`(max-width: ${MOBILE_WIDTH}px)`).pipe(map(result => result.matches)),
    );

    private isTablet = toSignal(
        this.breakPointObserver.observe(`(max-width: ${TABLET_WIDTH}px)`).pipe(map(result => result.matches)),
    );

    // Expose signal of current screen size to consumers
    screenSize: Signal<'mobile' | 'tablet' | 'desktop'> = computed(() => {
        if (this.isMobile()) {
            return 'mobile';
        } else if (this.isTablet()) {
            return 'tablet';
        } else {
            return 'desktop';
        }
    });
}
